import React from 'react'
import './card-component.scss'
import { ICardProps } from '../../types'
import { concatClassName } from '../../utils/helpers'

const Card = ({ classes, children, dataTestId }: ICardProps) => {
  return (
    <>
      <div
        className={`card-container ${concatClassName(classes)}`}
        {...(dataTestId ? { 'data-testid': dataTestId } : {})}
      >
        {children}
      </div>
    </>
  )
}

export { Card }
